<template src="./App.html"></template>
<style lang="scss" src="./App.scss"></style>

<script>


const default_layout = 'default';

import Vue from "vue";

export default Vue.extend({
  name: 'ShopTrinitas',

  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + '-layout';
    },
    locale: {
      get() {
        return this.$i18n.locale
      }
    }
  }, watch: {
    locale: function () {
      this.$store.dispatch('getCategoryTree')
    }
  },
  created() {
    this.$store.dispatch('getCategoryTree')

  },

});
</script>
